// extracted by mini-css-extract-plugin
export var cancelButton = "_pv-5";
export var content = "_pv-3";
export var createButton = "_pv-6";
export var drawerContainer = "_pv-0";
export var footer = "_pv-2";
export var header = "_pv-1";
export var orderFormColumn = "_pv-4";